import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

const COUPON_WALLET_STATE_MANAGER_KEY = 'COUPON_WALLET_STATE_MANAGER_KEY';

export const useCouponWalletStateManager = () => {
  const {cancel, isOpen, open} = useOpenedStateManager(
    COUPON_WALLET_STATE_MANAGER_KEY,
  );
  return {cancel, isOpen, open};
};
